import { WebImage, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('webImages');
export const findByIdThrows = createFindByIdThrows('webImages');

type GetFulfilledWebImages = (state: YammerState) => Record<string, WebImage>;
export const getFulfilledWebImages: GetFulfilledWebImages = (state) => state.webImages.fulfilled.byId;
